import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { DynamicComponentsService } from 'src/app/___LOGIC/__dynamicComponent/dynamic-components.service';

@Component({
  selector: 'app-transport-helper',
  templateUrl: './transport-helper.component.html',
  styleUrls: ['./transport-helper.component.css']
})
export class TransportHelperComponent implements OnInit,AfterViewInit {
  cities: string[] = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla'];
  selectedCity: string;
  publicTransport: any = {
    'Madrid': [
      { id: 1, name: 'Metro', description: 'The Madrid Metro is the fastest way to get around the city.' },
      { id: 2, name: 'Bus', description: 'The bus system in Madrid covers the entire city.' }
    ],
    'Barcelona': [
      { id: 1, name: 'Metro', description: 'The Barcelona Metro is extensive and easy to use.' },
      { id: 2, name: 'Bus', description: 'The bus network in Barcelona is efficient and reliable.' }
    ],
    'Valencia': [
      { id: 1, name: 'Metro', description: 'Valencia Metro is a convenient way to travel.' },
      { id: 2, name: 'Bus', description: 'Valencia has a comprehensive bus system.' }
    ],
    'Sevilla': [
      { id: 1, name: 'Metro', description: 'Sevilla Metro is the quickest way to get around.' },
      { id: 2, name: 'Bus', description: 'Sevilla’s bus system is well-connected.' }
    ]
  };
  tickets: any = {
    'Madrid': [
      { name: 'Single Ticket', description: 'Valid for one journey.', price: '€1.50' },
      { name: '10 Journey Ticket', description: 'Valid for 10 journeys.', price: '€12.20' }
    ],
    'Barcelona': [
      { name: 'Single Ticket', description: 'Valid for one journey.', price: '€2.20' },
      { name: 'T-10', description: '10 journey multi-person ticket.', price: '€10.20' }
    ],
    'Valencia': [
      { name: 'Single Ticket', description: 'Valid for one journey.', price: '€1.50' },
      { name: 'Bonometro', description: '10 journey ticket.', price: '€7.60' }
    ],
    'Sevilla': [
      { name: 'Single Ticket', description: 'Valid for one journey.', price: '€1.40' },
      { name: 'Bonobus', description: '10 journey ticket.', price: '€7.00' }
    ]
  };
  metroMapsOld: any = {
    'Madrid': [
      { city: 'Madrid', link: 'https://www.metromadrid.es/export/sites/metro/comun/documentos/Planos/Planoesquematicoespanol.pdf' }
    ],
    'Barcelona': [
      { city: 'Barcelona', link: 'https://www.tmb.cat/documents/20182/96227/Plano+Metro+Barcelona/4b4b7a9a-233c-4e8f-9a1f-6e0c62d5db36' }
    ],
    'Valencia': [
      { city: 'Valencia', link: 'https://www.metrovalencia.es/descarga/planos/2020-04-29_plano_esquematico.png' }
    ],
    'Sevilla': [
      { city: 'Sevilla', link: 'https://www.metro-sevilla.es/export/sites/metro/recursos/doc/planos/plano_oficial_metro_sevilla.pdf' }
    ]
  };

  metroMaps = [
    { city: 'Madrid', id: 'mapaMetroMadrid', link: 'https://www.metromadrid.es/export/sites/metro/comun/documentos/Planos/Planoesquematicoespanol.pdf',imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/b3da8c49-0a7f-4f1a-ac08-bdfb63e62600/public' },
    { city: 'Barcelona',id: 'mapaMetroBarcelona', link: 'https://www.tmb.cat/documents/20182/96227/Plano+Metro+Barcelona/4b4b7a9a-233c-4e8f-9a1f-6e0c62d5db36', imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/105a3fc6-d19e-4369-1df7-cbfb28453b00/public' },
    { city: 'Valencia',id: 'mapaMetroValencia', link: 'https://www.tmb.cat/documents/20182/96227/Plano+Metro+Barcelona/4b4b7a9a-233c-4e8f-9a1f-6e0c62d5db36', imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/f9b8a728-cc24-47c8-b05c-c7a5bde8b900/public' }
  ]
  prices: any = {
    'Madrid': [
      { item: 'Metro Single Ticket', cost: '€1.50' },
      { item: 'Bus Single Ticket', cost: '€1.50' },
      { item: 'Monthly Pass', cost: '€54.60' }
    ],
    'Barcelona': [
      { item: 'Metro Single Ticket', cost: '€2.20' },
      { item: 'Bus Single Ticket', cost: '€2.20' },
      { item: 'Monthly Pass', cost: '€54.00' }
    ],
    'Valencia': [
      { item: 'Metro Single Ticket', cost: '€1.50' },
      { item: 'Bus Single Ticket', cost: '€1.50' },
      { item: 'Monthly Pass', cost: '€45.00' }
    ],
    'Sevilla': [
      { item: 'Metro Single Ticket', cost: '€1.40' },
      { item: 'Bus Single Ticket', cost: '€1.40' },
      { item: 'Monthly Pass', cost: '€41.00' }
    ]
  };
  locations: any[] = [
    { lat: 40.4168, lng: -3.7038, label: 'M' }, // Madrid
    { lat: 41.3851, lng: 2.1734, label: 'B' }, // Barcelona
    { lat: 39.4699, lng: -0.3763, label: 'V' }, // Valencia
    { lat: 37.3886, lng: -5.9823, label: 'S' }  // Sevilla
  ];
  lat: number = 40.4168; // Example coordinates for Madrid
  lng: number = -3.7038;
  zoom: number = 6;
  origin: string = '';
  distances: any[] = [];

  cardIntro = {
    cardId: 'A', 
    imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/f6fa70c1-9806-41be-d049-c18ab688d800/public',
    imageSize: 'sm',
    title: 'Transporte en España',
    longPar: '',
    longParLimit: '250',
    shortPara: 'Si eres un estudiante extranjero que está a punto de embarcarse en una emocionante aventura académica en este hermoso país,es esencial que estés preparado para enfrentar el desafío de la movilidad en España.',
    description: 'En esta guía, te proporcionaremos información valiosa sobre cómo moverte en España de manera eficiente y económica, para que tu experiencia sea lo más placentera posible. \n\n',
    array: [
      {
        subtitle: '1. El Aeropuerto:',
        text: 'Es probable que llegues a uno de los principales aeropuertos de España, como el Aeropuerto de Barajas en Madrid o el Aeropuerto de El Prat en Barcelona. Desde el aeropuerto, tendrás varias opciones para llegar a tu destino final, ya sea una ciudad o una universidad. Taxi: Los taxis están disponibles en la mayoría de los aeropuertos y son una opción conveniente, pero también costosa. Asegúrate de preguntar por el precio estimado antes de subirte. Metro y Autobús: La mayoría de los aeropuertos tienen conexiones de metro y autobús que te llevarán al centro de la ciudad. Esta es una opción económica y eficiente.'
      },
      {
        subtitle: '2. Transporte Público en Ciudades:',
        text: ' En las principales ciudades de España, como Madrid, Barcelona, Valencia y Sevilla, encontrarás una excelente red de transporte público que incluye metro, autobuses y tranvías. Aquí tienes algunos consejos:Tarjeta de Transporte: Considera comprar una tarjeta de transporte público, como la Tarjeta T-Mes en Barcelona o la Tarjeta Multi en Madrid, que te dará acceso ilimitado a autobuses y metro durante un mes a un precio reducido.Horarios: Asegúrate de conocer los horarios de funcionamiento del transporte público en tu ciudad. En general, los servicios pueden ser menos frecuentes durante la noche y los fines de semana.'
      },
      {
        subtitle: '3. Trenes y Autobuses: ',
        text: 'Para viajar entre ciudades, España cuenta con una excelente red de trenes y autobuses. Aquí te recomendamos lo siguiente:Renfe: Si deseas viajar en tren, Renfe es la principal compañía ferroviaria en España. Puedes consultar horarios y comprar boletos en línea o en la estación de tren.Alsa: Para viajar en autobús, Alsa es una de las principales compañías de autobuses en España. Ofrecen rutas que conectan muchas ciudades y pueblos.'
      },
      {
        subtitle: '4. Viajar en Coche: ',
        text: 'Si prefieres la flexibilidad de viajar en coche, puedes alquilar un vehículo. Sin embargo, ten en cuenta que conducir en España puede ser un desafío, especialmente en las ciudades con tráfico denso y aparcamiento limitado.Peajes: En algunas autopistas, deberás pagar peajes. Asegúrate de tener efectivo o una tarjeta de crédito para pagarlos.'
      },
      {
        subtitle: '5. Aplicaciones de Transporte: ',
        text: 'En España, existen aplicaciones de transporte que pueden facilitar tu vida. Algunas de las más populares incluyen Uber, Cabify y las aplicaciones oficiales de transporte público de cada ciudad.Recuerda que España es un país hermoso con una amplia gama de destinos para explorar. Desde las playas en la costa mediterránea hasta las montañas de los Pirineos, tendrás muchas oportunidades de viajar y descubrir la rica cultura de este país.'
      }
    ]
  };

  transportImageCard = {
    title: 'Lo mejor para el transporte público',
    imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/84ff3d61-7347-4b27-1330-3fdb07b74e00/public',
    alt: 'People waiting for a subway at a metro station',
    category: 'Apps',
  }
  taxiApps = {
    cardId: 'A',
    title: 'Apps de Taxi',
    subtitle: 'Las mejores aplicaciones para moverte en Taxi',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    allVisible: false,
    array: [
      {
        title: 'FreeNow',
        imageUrl: this.guiFlow.getImage('34415cb9-caa8-4e48-034f-ed32113e2d00','icon'),
        description: 'FreeNow es una aplicación de transporte en España que te permite pedir taxis y VTC de manera rápida y segura. Ofrece una amplia cobertura en ciudades españolas para tu comodidad.',
        link: 'www.freenow.com'
      },
      {
        title: 'Cabify', 
        imageUrl: this.guiFlow.getImage('1b5fb967-0adf-4cc8-c624-28a14f775700','icon'),
        description: 'Cabify, la app de movilidad en España, te ofrece viajes cómodos y seguros. Elige entre coches privados o taxis, con conductor profesional. Reserva tu viaje con facilidad y paga sin efectivo.'
      },
      {
        title: 'Uber',
        imageUrl: this.guiFlow.getImage('1c734d4b-1321-4cd3-4bda-20251a74cd00','icon'),
        description: 'Uber en España te brinda comodidad y acceso rápido a viajes seguros. Con la aplicación, reserva vehículos con facilidad, sigue tu recorrido y paga de manera conveniente.'
      }
    ]
  };

  mobilityApps = {
    cardId: 'A',
    title: 'Apps de Movilidad',
    subtitle: 'Madrid, Barcelona,Valencia y más',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    allVisible: false,
    array: [
      {
        title: 'EMT',
        imageUrl: this.guiFlow.getImage('4b794f14-4a4a-412b-41aa-a5acaa2af500','icon'),
        link: 'https://opendata.emtmadrid.es/Aplicaciones',
        description:'La aplicación de EMT en España es una herramienta esencial para viajar en transporte público. Ofrece horarios, rutas y información en tiempo real para moverte de manera eficiente por las ciudades españolas.',
        visible: true
      },
      {
        title: 'Moovit',
        imageUrl: this.guiFlow.getImage('868e6819-2d46-42f3-e876-6fbab6468900','icon'),
        link:  'https://moovitapp.com/',
        description: 'Moovit es la aplicación esencial para el transporte en España. Encuentra rutas, horarios y actualizaciones en tiempo real para trenes, autobuses y metros, facilitando tus desplazamientos en todas las ciudades españolas.',
        visible: true
      },
      {
        title: 'Google Maps',
        imageUrl: this.guiFlow.getImage('bdad59e2-5bec-4acd-adb7-9c0e015e2a00','icon'),
        link:  'https://www.google.com/maps',
        description: '',
        visible: true
      },
      {
        title: 'TMB',
        imageUrl: this.guiFlow.getImage('0e55c9c6-531a-412e-68ef-796584f6ac00','icon'),
        link:  'https://moovitapp.com/',
        description: 'La TMB (Transports Metropolitans de Barcelona), es el sistema de transporte público que gestiona y opera una amplia red de servicios de transporte en la ciudad y sus alrededores. Esta red incluye metro, autobuses, tranvías y funiculares que conectan diferentes áreas de Barcelona y sus municipios cercanos.',
        visible: true
      }
    ]
  };

  flightWebsites = {
    cardId: 'D',
    title: 'Búsqueda de vuelos',
    subtitle: 'Sitios web muy populares',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: 'En los siguientes enlaces puedes realizar la búsqueda y comparación de precios de vuelos. Te recomendarmos comenzar la búsqueda por lo menos con 3 meses de antelación si es posible para encontrar mejores condiciones y precios.',
    longParLimit: '',
    shortPara: '',
    allVisible: false,
    array: [
      {
        title: 'SkyScanner',
        imageUrl: this.guiFlow.getImage('64a21a0e-de90-4db0-b8db-98f9262b6400','icon'),
        link: 'https://www.skyscanner.net/',
        label: 'www.skyscanner.com'
      },
      {
        title: 'Iberia',
        imageUrl: this.guiFlow.getImage('ec09a252-4c62-4adc-a387-938e2d59d300','icon'),
        link: 'https://www.iberia.com/',
        label: 'www.iberia.com'
      },
      {
        title: 'Iberojet',
        imageUrl: this.guiFlow.getImage('06df2f7b-88aa-45fd-dbf6-93e2a72aba00','icon'),
        link: 'https://www.iberojet.com/',
        label: 'www.iberojet.com'
      },
      {
        title: 'Kayak',
        imageUrl: this.guiFlow.getImage('07ae8e50-331b-4946-d4b4-969f2f80bc00','icon'),
        link: 'https://www.kayak.es/',
        label: 'www.kayak.es'
      },
      {
        title: 'Edreams',
        imageUrl: this.guiFlow.getImage('63033d73-9152-40cc-5d77-0301f9c57e00','icon'),
        link: 'https://www.edreams.es/',
        label: 'www.edreams.es'
      },
      {
        title: 'American Airlines',
        imageUrl: '../../assets/voyjaleas/userApp/transport/american.png',
        link: 'https://www.americanairlines.es/',
        label: 'www.americanairlines.es'
      },
      {
        title: 'KLM',
        imageUrl: this.guiFlow.getImage('4c2fe73b-1f03-410f-8f69-68a497fc7700','icon'),
        link: 'https://www.klm.com/home/cr/es',
        label: 'www.klm.com'
      },
      {
        title: 'Atrápalo',
        imageUrl: this.guiFlow.getImage('d88eebd9-7d70-4f19-3c50-bc51ebc4e000','icon'),
        link: 'https://www.atrapalo.com/',
        label: 'www.atrapalo.com'
      },
      {
        title: 'Momondo',
        imageUrl: this.guiFlow.getImage('d5cea2fd-1112-43fd-4085-cb076db8d500','icon'),
        link: 'https://www.momondo.es/',
        label: 'www.momondo.es',
        visible: false
      },
    ]
  };

  tablaPrecios = {
    cardId: 'tablaPrecios',
    title: 'Precios orientativos del transporte público en Madrid y Barcelona',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    dataArray: [
      
    ]
  };

  dataMetros = {
    title: 'Mapas de metro'
  }
  sections = [];
  
  bestOfArtists = [
    { title: 'Anderson Paak', description: 'The essential tracks, all in one.', imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/b3da8c49-0a7f-4f1a-ac08-bdfb63e62600/public' },
    { title: 'Kings of Leon', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Gorillaz', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Anderson Paak', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Kings of Leon', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Gorillaz', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
  ];

  @ViewChildren('dynamicElement') elements: QueryList<ElementRef<HTMLDivElement>>;

  constructor(private guiFlow: GuiFlowService,private router: Router,private dynamicComponentsService: DynamicComponentsService) {
    this.sections = [
      { id: 'intro', data: this.cardIntro, visible: true },
      { id: 'appsMobility', data: this.mobilityApps, visible: true },
      { id: 'mapasmetro', data: this.dataMetros, visible: true },
      { id: 'taxi', data: this.taxiApps, visible: true },
      { id: 'vuelos', data: this.flightWebsites, visible: true },
      { id: 'tarifas', data: this.tablaPrecios, visible: true }
    ];
  }

  ngOnInit(): void { }

  // AfterViewInit to register the elements
  ngAfterViewInit(): void {
    this.elements.forEach((el) => {
      const id = el.nativeElement.id; // Use the id attribute as the key
      this.dynamicComponentsService.registerElement(id, el);
    });
    console.log('Dynamic elements registered:', this.dynamicComponentsService);
  }

  selectCity(city: string) {
    this.selectedCity = city;
    const cityCoords = this.locations.find(location => location.label.charAt(0) === city.charAt(0));
    if (cityCoords) {
      this.lat = cityCoords.lat;
      this.lng = cityCoords.lng;
    }
  }

  calculateDistances() {
    // Simulate distance calculations
    this.distances = [
      { place: 'Central Station', km: 5 },
      { place: 'Airport', km: 20 },
      { place: 'University', km: 8 },
      { place: 'Shopping Center', km: 7 },
      { place: 'Beach', km: 15 }
    ];
  }

  openPdfModal(pdfId){
    this.router.navigateByUrl('pdf-view/'+pdfId);
  }

  // Scroll into view via the service
  scrollIntoView(key: string): void {
    this.dynamicComponentsService.scrollToElement(key);
  }

}